class SessionCache {
    setCache(key, value, isLocale) {
        sessionStorage.setItem(key, JSON.stringify(value)); //其中value必须是string类型；
    }
    getCache(key) {
        const value = sessionStorage.getItem(key);
        if (value !== null) {
            try {
                return JSON.parse(value);
            }
            catch (error) {
                return value;
            }
        }
        return value;
    }
    deleteCache(key) {
        sessionStorage.removeItem(key);
    }
    clearCache(excepts) {
        if (excepts && excepts.length) {
            const temp = [];
            excepts.forEach((k) => {
                if (sessionStorage.getItem(k) !== null) {
                    temp.push({ key: k, value: sessionStorage.getItem(k) });
                }
            });
            sessionStorage.clear();
            temp.forEach((t) => {
                sessionStorage.setItem(t.key, t.value);
            });
        }
        else {
            sessionStorage.clear();
        }
    }
}
class LocalCache {
    setCache(key, value, isLocale) {
        localStorage.setItem(key, JSON.stringify(value)); //其中value必须是string类型；
    }
    getCache(key) {
        const value = localStorage.getItem(key);
        if (value !== null) {
            try {
                return JSON.parse(value);
            }
            catch (error) {
                return value;
            }
        }
        return value;
    }
    deleteCache(key) {
        localStorage.removeItem(key);
    }
    clearCache(excepts) {
        if (excepts && excepts.length) {
            const temp = [];
            excepts.forEach((k) => {
                if (localStorage.getItem(k) !== null) {
                    temp.push({ key: k, value: localStorage.getItem(k) });
                }
            });
            localStorage.clear();
            temp.forEach((t) => {
                localStorage.setItem(t.key, t.value);
            });
        }
        else {
            localStorage.clear();
        }
    }
}
export const sessionCache = new SessionCache();
export const localCache = new LocalCache();
//# sourceMappingURL=cache.js.map